import { render, staticRenderFns } from "./ScreenTranslucenciaNucalDopplerMorfologica1Trimestre.vue?vue&type=template&id=b5c5f2fe&scoped=true&"
import script from "./ScreenTranslucenciaNucalDopplerMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalDopplerMorfologica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalDopplerMorfologica1Trimestre.vue?vue&type=style&index=0&id=b5c5f2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c5f2fe",
  null
  
)

export default component.exports